// extracted by mini-css-extract-plugin
export default {"scrubber":"Scrubber--scrubber--J0bpF","scrubberDark":"Scrubber--scrubberDark--KVb+m","scrubberLight":"Scrubber--scrubberLight--e07ak"};